import React, { useState, useEffect, useRef } from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { makeStyles } from "@material-ui/core/styles";
import { FinishModalStep1 } from "./FinishModalStep1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components/macro";
import { FinishModalStep2 } from "./FinishModalStep2";

const FinishModal = ({
  open,
  handleClose,
  ipDetails,
  property,
  propertySize,
  people,
  productsType,
}) => {
  const classes = useStyles();
  const [step, setStep] = useState(0);

  const stepRef = useRef(step);
  useEffect(() => {
    stepRef.current = step;
    if (step === 1)
      setTimeout(() => {
        if (stepRef.current !== 0) {
          window.location.href = "/";
        }
      }, 5000);
  }, [step]);

  return (
    <Modal
      disableEnforceFocus
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={() => {
        handleClose();
        setTimeout(() => setStep(0), 200);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Wrapper>
          {step === 0 ? (
            <FinishModalStep1 onPress={() => setStep(1)} />
          ) : (
            <FinishModalStep2 step={step} />
          )}
          <CloseWrapper
            onClick={() => {
              handleClose();
              setTimeout(() => setStep(0), 200);
            }}
          >
            <FontAwesomeIcon color={"#4b4b4b"} icon={faTimes} />
          </CloseWrapper>
        </Wrapper>
      </Fade>
    </Modal>
  );
};

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    "&:focus": {
      outline: 0,
    },
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: "none",
  },
}));

const Wrapper = styled.div`
  background-color: white;
  border-radius: 25px;
  outline: 0;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const CloseWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  margin: 15px;
  cursor: pointer;
`;
export { FinishModal };
